import { Link as LibraryLink } from "@zeguro/component-library"
import * as React from "react"

interface ILink {
  children?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  color?: string
  href?: string
  isUnderline?: boolean
  withIcon?: boolean
  padding?: string
  margin?: string
  id?: string
  fontSize?: string
  lineHeight?: string
  bold?: boolean
  onMouseEnter?: () => void
}

export const Link = ({
  children,
  onClick,
  disabled,
  href,
  withIcon,
  fontSize,
  ...restProps
}: ILink) => {
  return (
    <LibraryLink
      {...restProps}
      disabled={disabled}
      onClick={!disabled ? onClick : () => {}}
      href={href}
      target="_blank"
      isExternalLink={withIcon}
      fontSize={fontSize ?? "inherit"}
    >
      {children}
    </LibraryLink>
  )
}
